module.exports = __webpack_public_path__ + "static/media/icon-square-engagement-ratio.2a8b1f4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-square-engagement-ratio.svg
// module id = 741
// module chunks = 0